import { decimalDigits } from 'lib/decimal-digits';

export const isValidNumber = (value, allowZero = true, decimalLimit = 0) => {
  if ((typeof value === 'string' && value.includes('e')) || value.toString().includes('e')) {
    return false;
  }

  const p = Number(value);
  if (Number(p) === p) {
    if (p < 0 || (p === 0 && !allowZero) || decimalDigits(p) > decimalLimit) {
      return false;
    }
    return true;
  }

  return false;
};
